import src from "IMAGE";
export default { src, width: 210, height: 52, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AG6PSq1FWDBqNUMmVDVEJlE5SChdN0cnZkFULGE9TStjADNBJFY2RSZVNkYmVCw4H0Y4SCdaNEIkUz5PK2AtOCFKVCQQ0sq6+CYAAAAASUVORK5CYII="};
